import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../../contexts/AuthContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const PhotoDisplay = ({ url, className, alt = "Photo" }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const { token } = useAuth();
  
  useEffect(() => {
    const loadImage = async () => {
      if (!url) { setImageSrc(null); return; }
      if (url.includes('/api/files/')) {
        try {
          const fileId = url.split('/api/files/').pop().split('?')[0];
          const response = await axios.get(`${BACKEND_URL}/api/files/${fileId}`, {
            headers: token ? { Authorization: `Bearer ${token}` } : {}
          });
          const { data, content_type } = response.data;
          setImageSrc(`data:${content_type};base64,${data}`);
        } catch (e) { setImageSrc(null); }
      } else {
        setImageSrc(url);
      }
    };
    loadImage();
  }, [url, token]);
  
  if (!imageSrc) {
    return (
      <div className={`bg-muted flex items-center justify-center ${className}`}>
        <svg className="w-8 h-8 text-muted-foreground" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <path d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
        </svg>
      </div>
    );
  }
  
  return <img src={imageSrc} alt={alt} className={className} />;
};
